import { NavLink } from '../types/homepage'

export const navLinks: NavLink[] = [
  { label: 'How it works', href: '#how-it-works' },
  { label: 'Biometrics', href: '#biometrics' },
  { label: 'For therapists', href: '#therapists' },
  { label: 'FAQs', href: '#faqs' },
]
